module.exports = __webpack_public_path__ + "img/union.e5cf421e.svg";